<template>
    <div class="card mb-3">
        <div class="card-body">
            <Loading v-if="showLoading" />
            <div class="row">
                <div class="col-3">
                    <div class="nav flex-column nav-pills" id="v-pills-tab" role="tablist" aria-orientation="vertical">
                        <a class="nav-link mb-3 active" id="national-occasions-tab" data-toggle="pill" href="#national-occasions" role="tab" aria-controls="national-occasions" aria-selected="true">مناسبت های ملی</a>
                        <a class="nav-link mb-3" id="organization-occasions-tab" data-toggle="pill" href="#organization-occasions" role="tab" aria-controls="organization-occasions" aria-selected="true">مناسبت های سازمانی</a>
                        <a class="nav-link" id="personnel-occasions-tab" data-toggle="pill" href="#personnel-occasions" role="tab" aria-controls="personnel-occasions" aria-selected="true">مناسبت های پرسنل</a>
                    </div>
                </div>
                <div class="col-9">
                    <div class="tab-content">
                        <div class="tab-pane fade show active" id="national-occasions" role="tabpanel" aria-labelledby="national-occasions-tab">
                            <div class="row">
                                <div class="col-md-4">
                                    <label>انتخاب فایل</label>
                                    <div class="input-group file-browser">
                                        <input type="text" class="form-control border-left-0 browse-file" id="national-input-pan" placeholder="آپلود فایل" readonly="">
                                        <label class="input-group-btn mb-0">
                                            <span class="btn btn-primary">
                                                انتخاب کنید <input type="file" id="national-file-input" style="display: none;" accept=".xlsx" @input="setNationalExcelFile">
                                            </span>
                                        </label>
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="form-group">
                                        <label>تاریخ</label>
                                        <Datepicker simple auto-submit id="start-date" locale="fa" v-model="date" :locale-config="{
                                            fa: {
                                                displayFormat: 'jYYYY/jMM/jDD',
                                                lang: {label: 'شمسی'}
                                            }
                                        }" />
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="form-group">
                                        <label>مناسبت روز</label>
                                        <select class="form-control" :disabled="!nationalOccasions.length" v-model="nationalEventId">
                                            <option selected disabled>انتخاب کنید</option>
                                            <option v-for="(nationalOccasion,index) in nationalOccasions" :key="index" :value="nationalOccasion.eventId">{{ nationalOccasion.title }}</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-md-2">
                                    <button class="btn btn-secondary btn-block" style="margin-top: 29px;" @click="submitNational">ثبت اطلاعات</button>
                                </div>
                                <div class="col-md-2" v-if="nationalResponseFile">
                                    <button class="btn btn-info btn-block" style="margin-top: 29px;" @click="downloadResultFile(nationalResponseFile)">دریافت فایل نتیجه</button>
                                </div>
                                <div class="col-md-12">
                                    <a href="#" @click="e => downloadPanList(e,1)">دریافت لیست پن های ثبت شده</a>
                                </div>
                            </div>
                        </div>
                        <div class="tab-pane fade" id="organization-occasions" role="tabpanel" aria-labelledby="organization-occasions-tab">
                            <div class="row">
                                <div class="col-md-4">
                                    <label>انتخاب فایل</label>
                                    <div class="input-group file-browser">
                                        <input type="text" class="form-control border-left-0 browse-file" id="organization-input-pan" placeholder="آپلود فایل" readonly="">
                                        <label class="input-group-btn mb-0">
                                            <span class="btn btn-primary">
                                                انتخاب کنید <input type="file" id="organization-file-input" style="display: none;" accept=".xlsx" @input="setOrganizationExcelFile">
                                            </span>
                                        </label>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="form-group">
                                        <label>مناسبت هدیه</label>
                                        <select class="form-control" :disabled="!organizationOccasions.length" v-model="organizationEventId">
                                            <option selected disabled>انتخاب کنید</option>
                                            <option v-for="(organizationOccasion,index) in organizationOccasions" :key="index" :value="organizationOccasion.eventId">{{ organizationOccasion.title }}</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-md-2">
                                    <button class="btn btn-secondary btn-block" style="margin-top: 29px;" @click="submitOrganization">ثبت اطلاعات</button>
                                </div>
                                <div class="col-md-2" v-if="organizationResponseFile">
                                    <button class="btn btn-info btn-block" style="margin-top: 29px;" @click="downloadResultFile(organizationResponseFile)">دریافت فایل نتیجه</button>
                                </div>
                                <div class="col-md-12">
                                    <a href="#" @click="e => downloadPanList(e,2)">دریافت لیست پن های ثبت شده</a>
                                </div>
                            </div>
                        </div>
                        <div class="tab-pane fade" id="personnel-occasions" role="tabpanel" aria-labelledby="personnel-occasions-tab">
                            <div class="row">
                                <div class="col-md-4">
                                    <label>انتخاب فایل</label>
                                    <div class="input-group file-browser">
                                        <input type="text" class="form-control border-left-0 browse-file" id="personnel-input-pan" placeholder="آپلود فایل" readonly="">
                                        <label class="input-group-btn mb-0">
                                            <span class="btn btn-primary">
                                                انتخاب کنید <input type="file" id="personnel-file-input" style="display: none;" accept=".xlsx" @input="setPersonnelExcelFile">
                                            </span>
                                        </label>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="form-group">
                                        <label>مناسبت روز</label>
                                        <select class="form-control" v-model="personnelEventId">
                                            <option selected disabled>انتخاب کنید</option>
                                            <option value="1">تولد کارمند</option>
                                            <option value="2">تولد همسر</option>
                                            <option value="3">سالگرد ازدواج</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-md-2">
                                    <button class="btn btn-secondary btn-block" style="margin-top: 29px;" @click="submitPersonnel">ثبت اطلاعات</button>
                                </div>
                                <div class="col-md-2" v-if="personnelResponseFile">
                                    <button class="btn btn-info btn-block" style="margin-top: 29px;" @click="downloadResultFile(personnelResponseFile)">دریافت فایل نتیجه</button>
                                </div>
                                <div class="col-md-12">
                                    <a href="#" @click="e => downloadPanList(e,3)">دریافت لیست پن های ثبت شده</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: '',
    data(){
        return {
            showLoading: false,
            nationalFile: '',
            organizationFile: '',
            personnelFile: '',
            nationalOccasions: [],
            nationalResponseFile: '',
            organizationOccasions: [],
            organizationResponseFile: '',
            personnelOccasions: [],
            personnelResponseFile: '',
            date: '',
            nationalEventId: '',
            organizationEventId: '',
            personnelEventId: ''
        }
    },
    watch: {
        date(value){
            let date = value.replace(/\//g,'-');
            this.getEvents(date);
        }
    },
    methods: {
        getData(){
            const postedData = {
                eventType: [
                    2
                ],
                all: true
            };
            this.$api.post('Organizations/GetEvents',postedData).then(({data}) => {
                if(data.result.result)
                    this.organizationOccasions = data.result.result;
            });
        },
        async toBase64(file){
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = () => resolve(reader.result);
                reader.onerror = error => reject(error);
            });
        },
        async setNationalExcelFile(e){
            const file = e.target.files[0];
            const finalFile = await this.toBase64(file);
            this.nationalFile = finalFile;
            document.getElementById('national-input-pan').setAttribute('placeholder',file.name);
        },
        async setOrganizationExcelFile(e){
            const file = e.target.files[0];
            const finalFile = await this.toBase64(file);
            this.organizationFile = finalFile;
            document.getElementById('organization-input-pan').setAttribute('placeholder',file.name);
        },
        async setPersonnelExcelFile(e){
            const file = e.target.files[0];
            const finalFile = await this.toBase64(file);
            this.personnelFile = finalFile;
            document.getElementById('personnel-input-pan').setAttribute('placeholder',file.name);
        },
        getEvents(date){
            const postedData = {
                eventType: [
                    1
                ],
                fromDate: date,
                toDate: date
            };
            this.$api.post('Organizations/GetEvents',postedData).then(({data}) => {
                if(data.result.result && data.result.result.length){
                    this.nationalOccasions = data.result.result;
                }else
                    this.nationalOccasions = [];
            });
        },
        downloadPanList(e,eventType){
            e.preventDefault();
            this.$api.post('Organizations/GetEvents/Sheet/Card/List',{eventType}).then(({data}) => {
                let a = window.document.createElement('a');
                a.setAttribute('href','https://cardapi.sabinarya.com/api/v1/Lookup/download/' + data.result);
                let fileName = data.result;
                a.setAttribute('download',fileName);
                window.document.body.appendChild(a);
                a.click();
                window.document.body.removeChild(a);
            });
        },
        submitNational(){
            this.showLoading = true;
            const postedData = {
                file: this.nationalFile,
                eventType: 1,
                globalCalendarId: parseInt(this.nationalEventId)
            };
            this.$api.post('Organizations/Orders/Sheet',postedData).then(({data}) => {
                if(data.result.fileString)
                    this.nationalResponseFile = data.result.fileString;
                if(data.status){
                    this.$swal({
                        title: 'تبریک',
                        icon: 'success',
                        text: 'اطلاعات با موفقیت در سیستم ذخیره شد',
                        confirmButtonText: 'متوجه شدم'
                    });
                    this.nationalEventId = '';
                    this.date = '';
                    this.nationalOccasions = [];
                    this.nationalFile = '';
                    document.getElementById('national-file-input').value = '';
                    document.getElementById('national-input-pan').setAttribute('placeholder','انتخاب فایل');
                }
            }).finally(() => {
                this.showLoading = false;
            });
        },
        submitOrganization(){
            this.showLoading = true;
            const postedData = {
                file: this.organizationFile,
                eventType: 2,
                organizationCalendarId: parseInt(this.organizationEventId)
            };
            this.$api.post('Organizations/Orders/Sheet',postedData).then(({data}) => {
                if(data.result.fileString)
                    this.organizationResponseFile = data.result.fileString;
                if(data.status){
                    this.$swal({
                        title: 'تبریک',
                        icon: 'success',
                        text: 'اطلاعات با موفقیت در سیستم ذخیره شد',
                        confirmButtonText: 'متوجه شدم'
                    });
                    this.organizationEventId = '';
                    this.organizationFile = '';
                    document.getElementById('organization-file-input').value = '';
                    document.getElementById('organization-input-pan').setAttribute('placeholder','انتخاب فایل');
                }
            }).finally(() => {
                this.showLoading = false;
            });
        },
        submitPersonnel(){
            this.showLoading = true;
            const postedData = {
                file: this.personnelFile,
                eventType: 3,
                globalCalendarId: parseInt(this.personnelEventId)
            };
            this.$api.post('Organizations/Orders/Sheet',postedData).then(({data}) => {
                if(data.result.fileString)
                    this.personnelResponseFile = data.result.fileString;
                if(data.status){
                    this.$swal({
                        title: 'تبریک',
                        icon: 'success',
                        text: 'اطلاعات با موفقیت در سیستم ذخیره شد',
                        confirmButtonText: 'متوجه شدم'
                    });
                    this.personnelEventId = '';
                    this.personnelFile = '';
                    document.getElementById('personnel-file-input').value = '';
                    document.getElementById('personnel-input-pan').setAttribute('placeholder','انتخاب فایل');
                }
            }).finally(() => {
                this.showLoading = false;
            });
        },
        downloadResultFile(result){
            let a = window.document.createElement('a');
            a.setAttribute('href','https://cardapi.sabinarya.com/api/v1/Lookup/download/' + result);
            let fileName = result;
            a.setAttribute('download',fileName);
            window.document.body.appendChild(a);
            a.click();
            window.document.body.removeChild(a);
        }
    },
    created(){
        this.getData();
    }
}
</script>